<template>
    <div class="sos">
        <div class="jg-notice">
            <div class="jg-msg">
                <div>
                    <img src="../../assets/404.jpg">
                </div>
                <!--        <div>-->
                <!--          <van-button type="default" style="height: 40px;width: 160px;margin-top: -30px" @click="toHome">返回首页-->
                <!--          </van-button>-->
                <!--        </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getDeptId} from "./../../utils/auth";

    export default {
        name: 'home',
        components: {},
        created() {

        },

        methods: {
            toHome() {
                this.$router.push('/home/' + getDeptId())
            },
        },
    }
</script>

<style>
    .sos {
    }

    .jg-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
    }

    .jg-msg {
        text-align: center;
        margin-top: 100px;
    }
</style>
